import { MessageData } from "@/types";

export type MessageChangeCollection = Record<
  keyof MessageData,
  { oldValue: any; newValue: any }
>;

export class MessageChangeEvent {
  constructor(
    private _message: MessageData,
    private _payload: Partial<Omit<MessageData, "id">>
  ) {}

  get messageId() {
    return this._message.message_id;
  }

  changes() {
    const keys = Object.keys(this._payload) as (keyof MessageData)[];
    const changes: MessageChangeCollection = {} as MessageChangeCollection;
    keys.forEach((key) => {
      changes[key] = {
        oldValue: this._message[key],
        newValue: this._payload[key],
      };
    });
    return changes;
  }

  newMessage(): MessageData {
    return { ...this._message, ...this._payload };
  }

  hasChangeKey(key: keyof MessageData): boolean {
    return Object.prototype.hasOwnProperty.call(this._payload, key);
  }
}
